"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeycloakAuthClient = void 0;
var qs_1 = __importDefault(require("qs"));
var tiny_emitter_1 = require("tiny-emitter");
var ssr_1 = require("../internal/helpers/ssr");
/**
 * Keycloak tries to use the window as soon as it's imported for some reason.
 */
var Keycloak = !(0, ssr_1.isServer)() ? require('keycloak-js') : null;
/**
 * Keycloak needs to be initialised. It is not usable until then, so we'll keep track
 * of the status of the keycloak instance.
 */
var KeycloakAuthClientState;
(function (KeycloakAuthClientState) {
    KeycloakAuthClientState["CREATED"] = "CREATED";
    KeycloakAuthClientState["READY"] = "READY";
})(KeycloakAuthClientState || (KeycloakAuthClientState = {}));
function buildRedirectUrl(redirectUrl) {
    if (!redirectUrl) {
        return;
    }
    var fullUrl = redirectUrl.startsWith('/') ? "".concat(window.location.origin).concat(redirectUrl) : redirectUrl;
    return fullUrl;
}
/**
 * This is an auth client for Keycloak. It will automatically start the keycloak
 * service and will prevent it from breaking during SSR.
 */
var KeycloakAuthClient = /** @class */ (function () {
    function KeycloakAuthClient(options) {
        var _this = this;
        /**
         * This is called whenever the auth state might change. We use this as a callback
         * on many of the events emitted by Keycloak.
         */
        this.onAuthStateChange = function () {
            var authState = _this.getAuthState();
            var tokens = _this.serializeState();
            _this.persistor.set(tokens);
            _this.emitter.emit('onAuthStateChange', authState);
        };
        /**
         * Refresh the tokens.
         */
        this.onTokenExpired = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateTokens()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.config = options.config;
        this.initOptions = options.initOptions;
        this.loginOptions = options.loginOptions;
        // Create an emitter. Add event handlers to keycloak so there can be multiple subscribers
        this.emitter = new tiny_emitter_1.TinyEmitter();
        // Storing the tokens in storage
        this.persistor = options.tokenPersistor;
        // On these events we'll want to update the tokens.
        this.emitter.on('onReady', this.onAuthStateChange);
        this.emitter.on('onAuthSuccess', this.onAuthStateChange);
        this.emitter.on('onTokenRefresh', this.onAuthStateChange);
        this.emitter.on('onLogout', this.onAuthStateChange);
        this.emitter.on('onLogin', this.onAuthStateChange);
        // Auto-refresh the token when it expires
        this.emitter.on('onTokenExpired', this.onTokenExpired);
        // Initial state
        this.reset();
    }
    /**
     * Reset the keycloak instance.
     */
    KeycloakAuthClient.prototype.reset = function () {
        var _this = this;
        this.readyState = KeycloakAuthClientState.CREATED;
        this.initPromise = null;
        this.keycloak = Keycloak(this.config);
        this.keycloak.onAuthError = function (error) { return _this.emitter.emit('onAuthError', error); };
        this.keycloak.onAuthLogout = function () { return _this.emitter.emit('onLogout'); };
        this.keycloak.onAuthRefreshError = function () { return _this.emitter.emit('onAuthRefreshError'); };
        this.keycloak.onAuthRefreshSuccess = function () { return _this.emitter.emit('onAuthRefreshSuccess'); };
        this.keycloak.onAuthSuccess = function () { return _this.emitter.emit('onAuthSuccess'); };
        this.keycloak.onReady = function () { return _this.emitter.emit('onReady'); };
        this.keycloak.onTokenExpired = function () { return _this.emitter.emit('onTokenExpired'); };
    };
    /**
     * Get the current auth state from the auth client.
     */
    KeycloakAuthClient.prototype.getAuthState = function () {
        var _a = this.keycloak, token = _a.token, idToken = _a.idToken;
        var isReady = this.readyState === KeycloakAuthClientState.READY;
        var isLoggedIn = !!(token && idToken);
        if (isReady && isLoggedIn) {
            return {
                state: 'LOGGED_IN',
                isReady: isReady,
                isLoggedIn: isLoggedIn,
                token: token,
                idToken: idToken,
            };
        }
        if (isReady && !isLoggedIn) {
            return {
                state: 'NOT_LOGGED_IN',
                isReady: isReady,
                isLoggedIn: isLoggedIn,
                token: undefined,
                idToken: undefined,
            };
        }
        return {
            state: 'NOT_READY',
            isReady: false,
            isLoggedIn: false,
            token: undefined,
            idToken: undefined,
        };
    };
    /**
     * This will return the keycloak tokens but it will update the tokens if needed, so this
     * function is async.
     */
    KeycloakAuthClient.prototype.updateTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.readyState !== KeycloakAuthClientState.READY) {
                            return [2 /*return*/, undefined];
                        }
                        // Update the token if it's going to expire in the next 30 seconds.
                        return [4 /*yield*/, this.keycloak
                                .updateToken(30)
                                .catch(function (e) {
                                _this.persistor.clear();
                                console.error('Failed to update access token.');
                            })
                                .then(function (refreshed) {
                                if (refreshed) {
                                    _this.emitter.emit('onTokenRefresh');
                                }
                            })];
                    case 1:
                        // Update the token if it's going to expire in the next 30 seconds.
                        _a.sent();
                        if (this.keycloak.token && this.keycloak.idToken) {
                            return [2 /*return*/, {
                                    token: this.keycloak.token,
                                    idToken: this.keycloak.idToken,
                                }];
                        }
                        return [2 /*return*/, undefined];
                }
            });
        });
    };
    /**
     * Get the tokens from keycloak instance.
     */
    KeycloakAuthClient.prototype.serializeState = function () {
        if (!this.keycloak.authenticated) {
            return undefined;
        }
        return {
            token: this.keycloak.token,
            idToken: this.keycloak.idToken,
            refreshToken: this.keycloak.refreshToken,
        };
    };
    /**
     * Subscribe to auth state changes.
     */
    KeycloakAuthClient.prototype.subscribe = function (fn) {
        var _this = this;
        this.emitter.on('onAuthStateChange', fn);
        return function () {
            _this.emitter.off('onAuthStateChange', fn);
        };
    };
    /**
     * Log the current user out and kill the session.
     * @param redirectUri URL to redirect the user after the logout is complete.
     */
    KeycloakAuthClient.prototype.logout = function (redirectUri) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.keycloak.logout({
                            redirectUri: redirectUri,
                        })];
                    case 1:
                        _a.sent();
                        this.emitter.emit('onLogout');
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Log the user in by redirecting them to the login page.
     * @param redirectUri URL to redirect the user after the login is complete. Defaults to the current page.
     */
    KeycloakAuthClient.prototype.login = function (redirectUri) {
        return __awaiter(this, void 0, void 0, function () {
            var fullRedirectUrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Keycloak needs .init called before trying to login.
                        if (this.readyState !== KeycloakAuthClientState.READY) {
                            throw new Error('Keycloak service not started');
                        }
                        if (!!this.keycloak.authenticated) return [3 /*break*/, 2];
                        fullRedirectUrl = buildRedirectUrl(redirectUri || this.loginOptions.redirectUri);
                        return [4 /*yield*/, this.keycloak
                                .login({
                                idpHint: this.loginOptions.idpHint,
                                redirectUri: fullRedirectUrl,
                            })
                                .catch(function (e) {
                                _this.persistor.clear();
                                throw e;
                            })];
                    case 1:
                        _a.sent();
                        this.emitter.emit('onLogin');
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    KeycloakAuthClient.prototype.swap = function (targetClient, swapContext) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.readyState !== KeycloakAuthClientState.READY) {
                            throw new Error('Keycloak service not started');
                        }
                        return [4 /*yield*/, fetch("".concat(this.config.url, "/realms/").concat(this.config.realm, "/protocol/openid-connect/token"), {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Content-type': 'application/x-www-form-urlencoded',
                                },
                                body: qs_1.default.stringify(__assign({ grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange', client_id: this.config.clientId, audience: targetClient, requested_token_type: 'urn:ietf:params:oauth:token-type:refresh_token', subject_token: this.keycloak.token }, (swapContext !== null && swapContext !== void 0 ? swapContext : {}))),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, {
                                token: data.access_token,
                                refreshToken: data.refresh_token,
                            }];
                }
            });
        });
    };
    /**
     * Start the auth service. This will begin listening to auth state changes and watching
     * for token updates.
     * @returns boolean Did it successfully start?
     */
    KeycloakAuthClient.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cachedTokens;
            var _this = this;
            return __generator(this, function (_a) {
                // If we've already started the service, just return the existing promise
                if (this.initPromise) {
                    return [2 /*return*/, this.initPromise];
                }
                cachedTokens = this.persistor.get();
                // Store the promise so that it can only be initialised once.
                // Once it has been started it can't be started again unless
                // you call .stop.
                this.initPromise = this.keycloak
                    .init(__assign(__assign(__assign({ pkceMethod: 'S256' }, this.initOptions), (cachedTokens || {})), { timeSkew: 0 }))
                    .then(function () {
                    // After keycloak is initialised, if it's not authenticated due to a callback or
                    // from pulling the tokens from the cache, we should clear the cache.
                    if (!_this.keycloak.authenticated) {
                        _this.persistor.clear();
                    }
                    _this.readyState = KeycloakAuthClientState.READY;
                    _this.emitter.emit('onReady');
                    return true;
                })
                    .catch(function (e) {
                    _this.emitter.emit('onInitError', e);
                    _this.persistor.clear();
                    throw e;
                });
                return [2 /*return*/, this.initPromise];
            });
        });
    };
    /**
     * Stop the auth service and reset everything.
     */
    KeycloakAuthClient.prototype.stop = function () {
        this.reset();
        return true;
    };
    return KeycloakAuthClient;
}());
exports.KeycloakAuthClient = KeycloakAuthClient;
